import React, { Fragment } from "react";
/* -- LAYOUT OBJECTS - */
import Sidebar from "../component/sidebar";
import Container from "./container";
import MainDisplay from "./main-display";
/* -- LAYOUT OBJECTS - */
import UiKit from "../../../../common/uikit";

const DasboardLayout = (props) => {
  const p = props;
  return (
    <Fragment>
        <Container>
            <Sidebar />
            <MainDisplay>
                <div className="dashboard-container-page">{p.children}</div>
            </MainDisplay>
        </Container>
      <UiKit.Toast />
      <UiKit.Modal />
    </Fragment>
  );
};

export default DasboardLayout;
